import React, { useState } from 'react'
import logo from './Images/kpn-logo.png';
import { FaBars , FaTimes } from 'react-icons/fa';


export const Header = () => {

  const [icon, setIcon] = useState(false)
    const handleClick = () =>{
        setIcon(!icon)
    }
    const closeSideDrawer = () =>{
      setIcon(false)
  }

  return (
    <div className='header'>

        <div className='logo'>
        <img src={logo} alt='logo' />
        </div>

        <div>
            <ul className={ icon ? 'nav-menu active' : 'nav-menu menulist'}>
                <li className = 'nav-links' onClick={closeSideDrawer}>Home</li>
                <li className = 'nav-links' onClick={closeSideDrawer}>About</li>
                <li className = 'nav-links' onClick={closeSideDrawer}>Branches</li>
                <li className = 'nav-links' onClick={closeSideDrawer}>Blog</li>
                <li className = 'nav-links' onClick={closeSideDrawer}>Contact Us</li>
                <li  className = 'nav-links' onClick={closeSideDrawer}><span>OFFERS</span></li>
            </ul>
        </div>

        <div className='menu-icon' onClick={handleClick}>{
        icon ? <FaTimes className='fa-times'></FaTimes> : <FaBars className='fa-bars'></FaBars> }
        </div>

    </div>
  )
}
